/* eslint-disable import/no-cycle */
/* eslint-disable react/prop-types */
import React, {useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './canvasComponent.scss';
import {IconType} from '../../atoms/icon/icon';
import Button, { ButtonSize, ButtonType } from '../../atoms/button/button';
import { ButtonTheme } from '../../atoms/button/button';
import '../../../theme.scss';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import CanvasContainers from './canvasContainers';
import swal from 'sweetalert';
import Toaste from '../../atoms/toast/toaste';
import TimelineComponent from './timelineComponent';
import { getContainerIndex, getTimestampFromDate15Min, randomNumberInRange } from '../../../utils/canvasUtils';
import moment from "moment";
import { httpPost } from '../../../store/externalCalls/httpCalls';

import FormSelect from '../../molecules/formSelect/formSelect';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { storeStructure } from '../../../store/reducers';
import { createCanvasContentInfo, resetCanvasContentInfo} from '../../../store/actions/canvasContentInfoActions';
import TimelineDatePicker from './timelineDatePicker/timelineDatePicker';
import recenterIcon from '../../atoms/customIcons/recenterIcon.svg'; 
import FormConfirmSelect from '../../molecules/formConfirmSelect/formConfirmSelect';
import { OPERATING_SYSTEMS } from '../../../utils/operatingSystemUtils';
import CanvasContainersScrollable from './canvasContainersScrollable';
import { types as sessionTypes } from "../../../store/reducers/sessionReducer"; 

/**
 * Canvas component 
 */
const CanvasComponent = (props) => {
   const dispatch = useDispatch();
  const { values, onEdited, onPublish   } = props;

  useEffect(() => {
    if (values?.operatingSystem) {
      dispatch({
        type: sessionTypes.POST,
        payload: {
          operatingSystem: values.operatingSystem,
        },
      });
    }
  }, [values?.operatingSystem, dispatch]);


  const viewModes = [
    { name: 'Edition', value: '1' },
    { name: 'Preview', value: '2' },
  ];

  const [modePreview,setModePreview] =useState('1');
  const [popupMessages,setPopupMessages] =useState({});
  const [maxContainers,setMaxContainers] =useState(5);
  const [canvasModified,setCanvasModified] =useState(false);
  const [originalContainers,setOriginalContainers] =useState(null);
  const [containersMiddle,setContainersMiddle]=useState(null);
  const [containersTop,setContainersTop]=useState(null);
  const [containersBottom,setContainersBottom]=useState(null);
  const [infoContent,setInfoContent] =useState(null);
  const [dateSelected,setDateSelected] =useState(getTimestampFromDate15Min(null,Date.now()));
  const CanvasInfoContent = useSelector((state) => state[storeStructure.CanvasContentInfo], shallowEqual);
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const [triggerRefresh,setTriggerRefresh] =useState(false);
  const [dataToTimeline,setDataToTimeline]=useState({});
  const [blockSelected,setBlockSelected] =useState(null);
  const [updateCanvas,setUpdateCanvas] =useState(null);
  const [canvasType,setCanvasType] =useState('containers');

  var minTime = moment().add(-3, "months").valueOf();

  var maxTime = 0;
  var maxTimeDisplayTimeline = moment().add(10, "years").valueOf();
  const onUpdate=(data,canvasMode)=>{
    let prevData=dataToTimeline;
    prevData.data[canvasMode]=data;
    setDataToTimeline({time:new Date(),data:prevData.data});
    switch(canvasMode){
      case "Top":
        setContainersTop(data);
      break;
      case "Middle":
        setContainersMiddle(data);
      break;
      case "Bottom":
        setContainersBottom(data);
      break;
    }
    setCanvasModified(true);
    onEdited(true);
  }
  const onUpdateInfoContent=(newElem)=>{
    dispatch(createCanvasContentInfo([newElem]));
    setTimeout(()=>{
      setTriggerRefresh(true);
    },1000);
    setTimeout(()=>{
      setTriggerRefresh(false);
    },1000);
  }
  const clearInfoContent=()=>{
    dispatch(resetCanvasContentInfo());
  }

  //Create a container
  const onNewContainer=(index,canvasMode)=>{
    let containerNumber=getContainerIndex(index,maxContainers);
    let updateContainers={};
    updateContainers.Top=containersTop;
    updateContainers.Middle=containersMiddle;
    updateContainers.Bottom=containersBottom;
    switch(canvasMode){
      case "Top":
        updateContainers.Top[index]={...updateContainers.Top[index],UID:randomNumberInRange(100000000000,999999999999),"created":true,"blocks":[],id:"new",container:containerNumber,canvasId:values.id};
        setContainersTop(updateContainers.Top);  
      break;
      case "Middle":
        updateContainers.Middle[index]={...updateContainers.Middle[index],UID:randomNumberInRange(100000000000,999999999999),"created":true,"blocks":[],id:"new",container:containerNumber,canvasId:values.id};
        setContainersMiddle(updateContainers.Middle);  
      break;
      case "Bottom":
        updateContainers.Bottom[index]={...updateContainers.Bottom[index],UID:randomNumberInRange(100000000000,999999999999),"created":true,"blocks":[],id:"new",container:containerNumber,canvasId:values.id};
        setContainersBottom(updateContainers.Bottom);  
      break;
    }

    setDataToTimeline({time:new Date(),data:updateContainers});
    setCanvasModified(true);

  }

  //Delete a container
  const onDeleteContainer=(index,canvasMode)=>{
    swal({
      title:"Delete container",
      text: "Are you sure you want to delete this container?",
      buttons: true,
      dangerMode: true,
    }).then((value) => {
      if(value){
        let tempContainers=null;
        switch(canvasMode){
          case "Top":
            tempContainers=[...containersTop];
          break
          case "Middle":
            tempContainers=[...containersMiddle];
          break;
          case "Bottom":
            tempContainers=[...containersBottom];
          break;
        }
        
        let value=tempContainers[index];
        let uidFound=randomNumberInRange(100000000000,999999999999);
        if(value.UID)
          uidFound=value.UID;
        let newValue={UID:uidFound,created:false,container:value.container};
        tempContainers[index] = newValue;
        let data={};
        switch(canvasMode){
          case "Top":
            setContainersTop(tempContainers);
            data.Top=tempContainers;
            data.Middle=containersMiddle;
            data.Bottom=containersBottom;
          break
          case "Middle":
            setContainersMiddle(tempContainers);
            data.Middle=tempContainers;
            data.Top=containersTop;
            data.Bottom=containersBottom;

          break;
          case "Bottom":
            setContainersBottom(tempContainers);
            data.Bottom=tempContainers;
            data.Middle=containersMiddle;
            data.Top=containersBottom;
          break;
        }
        // console.log("data",data,values);
        setCanvasModified(true);
        setDataToTimeline({time:new Date(),data:data});

      }
    });
  }
  const handlePublishContainers=(funcOk=null,funcError=null)=>{
    try{
      onPublish(values);
      setOriginalContainers(values);
      if(typeof funcOk === "function")
        funcOk();
    }catch(e){
      if(typeof funcOk === "function")
        funcError();
    }
  }
  const handlePublish=(funcOk=null,funcError=null)=>{
    let newValues=values;

    if(canvasModified){
      swal({
        title:"Publish changes",
        text: "Are you sure you want to publish the changes?",
        buttons: true,
        dangerMode: true,
      }).then((value) => {
        if(value){
          // console.log("1",value,containersTop);
          if(containersTop && containersTop.length>0){
            newValues.canvas.containersTop=containersTop;
          }
          else
          newValues.canvas.containersTop=[];

          if(containersMiddle && containersMiddle.length>0){
            newValues.canvas.containersMiddle=containersMiddle;
          }
          else
          newValues.canvas.containersMiddle=[];

          if(containersBottom && containersBottom.length>0){
            newValues.canvas.containersBottom=containersBottom;
          }
          else
          newValues.canvas.containersBottom=[];
          onPublish(newValues);
          setOriginalContainers(newValues);
          setCanvasModified(false);
          setPopupMessages(["Changes published!"]);
          setTimeout(() => {
            setPopupMessages({});
            if(typeof funcOk === "function")
              funcOk();
          }, 2000);
        }else{
          if(typeof funcError ==="function")
            funcError();
        }
      });
    }else{
      setPopupMessages(["No changes made on the canvas"]);
      setTimeout(() => {
        setPopupMessages({});
        if(funcError)
          funcError();
      }, 2000);
    }
  }
  
  const handleDiscardChanges=()=>{
    if(canvasModified){
      swal({
        title:"Discard changes",
        text: "Are you sure you want to discard changes?",
        buttons: true,
        dangerMode: true,
      }).then((value) => {
        if(value){
          getCanvas(true);
          clearInfoContent();
          setPopupMessages(["Changes discarded!"]);
          onEdited(false);
          setTimeout(() => {
            setPopupMessages({});
          }, 2000);
          }
      });
    }else{
      setPopupMessages(["No changes made on the canvas"]);
      setTimeout(() => {
        setPopupMessages({});
      }, 2000);
    }
  }
  
  const drawContainers=(containers,pos)=>{
        setContainersTop(null);
        setContainersMiddle(null);
        setContainersBottom(null);
        setTimeout(() => {
          setContainersTop(containers["Top"]);  
          setContainersMiddle(containers["Middle"]);  
          setContainersBottom(containers["Bottom"]);  
          setDataToTimeline({time:new Date(),data:containers});
          setUpdateCanvas(new Date());
        }, 1);
    
  }

  const checkContainers=(val)=>{
    let position=["Top","Middle","Bottom"];
    let allContainers=[];
    position.forEach((pos)=>{
      let tempContainers=[...val.canvas["containers"+pos]];
      if(!val.canvas["containers"+pos])
        tempContainers=[...originalContainers[pos]];
        let returnContainers=[];
        for(let i=0;i<=val.maxContainers-1;i++){
          let index=getContainerIndex(i,val.maxContainers);
          let found= tempContainers.find((elem=>elem["container"]===index));
          if(found){
            found.created=true;
            returnContainers=[...returnContainers,found];
          }else{
            returnContainers=[...returnContainers,{created:false, UID:randomNumberInRange(100000000000,999999999999),container:index}];  
          }
        }
        tempContainers=returnContainers;
        allContainers[pos]=tempContainers;
    });
    drawContainers(allContainers);
  } 

  const getCanvas=(init=false)=>{
    if(originalContainers==null){
      setOriginalContainers(JSON.parse(JSON.stringify(values)));
    }
    if(!values.maxContainers)
      setMaxContainers(5);
    else
      setMaxContainers(values.maxContainers);
      checkContainers(JSON.parse(JSON.stringify(values)));
    setCanvasModified(false);
  }
  const handleRecenterCanvas=()=>{
    const container = document.querySelector('.groupContainers');
    const containerWidth = container.scrollWidth; // Total width of scrollable content
    const containerVisibleWidth = container.clientWidth; // Width of visible container area
    const scrollLeft = container.scrollLeft; // Current horizontal scroll position
    let realCenter=containerWidth/2;
    let middleVisible=containerVisibleWidth/2;
    let sl=realCenter-middleVisible;
    container.scrollLeft=sl;
  }
  useEffect(()=>{
    setOriginalContainers(null);
    setInfoContent([]);
    let calledFirstScroll=false;
    const container = document.querySelector('.groupContainers');

    const verticalLine =document.querySelector('.vertical-line');

    const topScrollbar = document.querySelector('.topScrollbar');
    const topContent=document.querySelector('.topScrollbarContent');
  
    function updateScroll(){
      container.scrollLeft=topScrollbar.scrollLeft;
    }


    function updateVerticalLinePosition() {
      topContent.style.width=container.scrollWidth+"px";
      topScrollbar.scrollLeft=container.scrollLeft;

      const containerWidth = container.scrollWidth; // Total width of scrollable content
      const containerVisibleWidth = container.clientWidth; // Width of visible container area
      const scrollLeft = container.scrollLeft; // Current horizontal scroll position
      let realCenter=containerWidth/2;
      let isVisible=(scrollLeft+containerVisibleWidth>realCenter || (scrollLeft<realCenter && scrollLeft>0));
      let newLeft="inherit";
      let newRight="inherit";
      if(isVisible){
        newLeft=(realCenter-scrollLeft+20)+"px";
        verticalLine.style.backgroundColor="#0B23FF";
      }else{
        if(scrollLeft>realCenter && scrollLeft>0){
          newLeft=0+"px";
          newRight="inherit";
          if(verticalLine)
            verticalLine.style.backgroundColor="#7682f1";
        }else{
          newLeft="inherit";
          newRight=0+"px";
          if(verticalLine)
            verticalLine.style.backgroundColor="#7682f1";
        }
      }
      verticalLine.style.left =newLeft;
      verticalLine.style.right =newRight;
      if(calledFirstScroll==false){
        setTimeout(()=>{
          updateVerticalLinePosition();
          topContent.style.width=container.scrollWidth+"px";
          calledFirstScroll=true;
          
        },1000);
      }
    }

    // Initial position
    updateVerticalLinePosition();

    // Update position on scroll
    container.addEventListener('scroll', updateVerticalLinePosition);
    topScrollbar.addEventListener('scroll',updateScroll);
    window.addEventListener('resize', updateVerticalLinePosition);

  },[]);

  useEffect(() => {
    if(values && values.canvas &&  Object.keys(values).length>0){
      setOriginalContainers(null);
      getCanvas(false);
      setDataToTimeline({time:new Date(),data:values.canvas});
    }
    
    const verticalLine =document.querySelector('.vertical-line');

    if(values.operatingSystem==OPERATING_SYSTEMS.oculusQuest.key) 
      verticalLine.style.display="block";
    else{
      verticalLine.style.display="none";
    }
  },[values]);


  const CanvasPreviewButtons=(props)=>{
    const {}=props;
    return (
      <div>
        <div className="canvas-preview canvas-preview-text"><div>Canvas Design</div></div>
      <div className="canvas-preview">
        <div className="canvas-preview-elem">
          
            <ButtonGroup className="toggle-button">
                {viewModes.map((mode, idx) => (
                  <ToggleButton
                    key={idx}
                    className={idx % 2 ? 'toggle-right' : 'toggle-left'}
                    id={`mode-${idx}`}
                    type="radio"
                    value={mode.value}
                    checked={modePreview === mode.value}
                    onChange={(e) => setModePreview(e.currentTarget.value)}
                  >
                    {mode.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
          </div>
          {values.operatingSystem==OPERATING_SYSTEMS.oculusQuest.key && <div className="recenter-text"><button onClick={handleRecenterCanvas}><img src={recenterIcon}/> Recenter Canvas</button></div>}
      </div>
      </div>
    );
  }

  const CanvasPublishButtons=(props)=>{
    const {position} =props;
    return (
      <div className="canvas-publish-buttons">
            <Button
              id={"button-discard-"+position}
              // className={"button-discard"}
              // theme={ButtonTheme.DARK}
              size={ButtonSize.MEDIUM}
              // icon={IconType.CLOSE}
              title="Discard changes"
              onClick={handleDiscardChanges}
              disabled={canvasModified?false:true}
            >Discard
            </Button>
            <Button
              id={"button-publish-"+position}
              className={"button-publish"}
              theme={ButtonTheme.PRIMARY}
              size={ButtonSize.MEDIUM}
              title="Publish changes to server"
              onClick={handlePublish}
              disabled={canvasModified?false:true}
            >
              {canvasModified?"Publish changes":"Published!"}
            </Button>
          </div>
    );
  }

  const handleChangeDateTimeline=(d)=>{
    setDateSelected(d);
  }

  const handleOnSelectItem=(el)=>{
    setBlockSelected(el);
  }

  const handleOnDeselectItem=()=>{
  }

  const handleOnMoveTime=(t)=>{
    let timestamp15 = getTimestampFromDate15Min(null,t);
    setDateSelected(timestamp15);
  }

  const handleOnDeleteBlock=(el,time)=>{
    deleteBlockFromContainers(el,time);
  }
  const fillBlockContainers=(containers,blockToFillId)=>{
    let blockToFill=null;
    let allContainerBlocks=null;
    let filledContainer=containers.map((container,index)=>{
      let updatedContainer=container;
      let found=false;
      if(container.blocks){
        container.blocks.map((block,index)=>{
          if(found==false && block.UID===blockToFillId){
            found=true;
            blockToFill=block;
            allContainerBlocks=container.blocks;
            let params={"block":blockToFill,"allBlocks":allContainerBlocks,"dateSelected":dateSelected};
            httpPost('canvasCheckBlock', params).then((res)=>{
              let newEndEpoch=res["block"]["endEpoch"];
              blockToFill["endEpoch"] = newEndEpoch;
             
              return blockToFill;
            });
          }else{
            return block;
          }
        });
        if(found){
          updatedContainer.blocks=container.blocks;
        }else{
          updatedContainer=container;
        }

      }
      return updatedContainer;
    });
    return filledContainer;
  }
  const handleOnFillBlock=(blockToFillId)=>{
    let fillText="You are about to fill the block as far as posible";
    let filledMiddle=fillBlockContainers(containersMiddle,blockToFillId);
    let filledTop=fillBlockContainers(containersTop,blockToFillId);
    let filledBottom=fillBlockContainers(containersBottom,blockToFillId);
    swal({
      title: 'Are you sure?',
      text: fillText,
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if(ok){
        setCanvasModified(true);
        setContainersMiddle(filledMiddle);
        setContainersTop(filledTop);
        setContainersBottom(filledBottom);
        setUpdateCanvas(new Date());
        setDateSelected(dateSelected+1);
        setDateSelected(dateSelected);
        let updateContainers={};
        updateContainers.Top=filledTop;
        updateContainers.Middle=filledMiddle;
        updateContainers.Bottom=filledBottom;
        setDataToTimeline({time:new Date(dateSelected),data:updateContainers})
      }
    });
  }
  const updateDeleteContainer=(containers,blockToDelete,time)=>{
    let found=false;
    let deleteText="";
    let updatedContainer=containers.map((container,index)=>{
      let deleteIds=[];
      let updatedContainer=container;
      if(container.blocks){
        container.blocks.map((block,index)=>{
          if(block.UID===blockToDelete){
            found=true;
            if(block.startEpoch>=time){
              deleteIds.push(index);   
              deleteText="You are about to remove the entire block";
            }else{
              deleteText="You are about to remove the block from this date \n("+moment.unix(time/1000).format('DD-MM-YYYY HH:mm:ss')+")";
              block.endEpoch=time;
            }
          }
          return block;
        });

        if(found){
          let cleanBlocks = container.blocks.filter((block, index) =>{
            return deleteIds.indexOf(index) == -1;
          });
          updatedContainer.blocks=cleanBlocks;            }
        }
        return updatedContainer;
    });
    return updatedContainer; 
  }

  const deleteBlockFromContainers=(blockToDelete,time)=>{
    let deleteText="";
    let updatedContainerMiddle=updateDeleteContainer(containersMiddle,blockToDelete,time);
    let updatedContainerTop=updateDeleteContainer(containersTop,blockToDelete,time);
    let updatedContainerBottom=updateDeleteContainer(containersBottom,blockToDelete,time);
    swal({
      title: 'Are you sure?',
      text: deleteText,
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if(ok){
        setContainersMiddle(updatedContainerMiddle);
        setContainersTop(updatedContainerTop);
        setContainersBottom(updatedContainerBottom);
        setUpdateCanvas(new Date());
        setDateSelected(dateSelected+1);
        setDateSelected(dateSelected);
        setCanvasModified(true);
        let updateContainers={};
        updateContainers.Top=updatedContainerTop;
        updateContainers.Middle=updatedContainerMiddle;
        updateContainers.Bottom=updatedContainerBottom;
        setDataToTimeline({time:new Date(time),data:updateContainers})
      }
    });
  }
  const handleMoveAndSelectItem=(el)=>{
    let found=false;
    let position=["Top","Middle","Bottom"];
    
    position.forEach((pos)=>{
      for(let i=0;i<dataToTimeline.data[pos].length;i++){
        if(dataToTimeline.data[pos][i].blocks){
          for(let j=0;j<dataToTimeline.data[pos][i].blocks.length;j++){
            if(el==dataToTimeline.data[pos][i].blocks[j].UID){
              found=true;
              setDateSelected(dataToTimeline.data[pos][i].blocks[j].startEpoch);
              break;
            }
          }
        }
        if(found==true)
          break;
      }
    });
  }
  const handleOnBlockSelected=(uid)=>{
    setBlockSelected(uid);
  }
  const handleOnMoveToEnd=(el)=>{
    let found=false;
    for(let i=0;i<dataToTimeline.data.length;i++){
      if(dataToTimeline.data[i].blocks){
        for(let j=0;j<dataToTimeline.data[i].blocks.length;j++){
          if(el==dataToTimeline.data[i].blocks[j].UID){
            found=true;
            setDateSelected(dataToTimeline.data[i].blocks[j].endEpoch);
            break;
          }
        }
      }
      if(found==true)
        break;
    }
  }
  const handleOnChangeMaxContainers=(v)=>{
    setMaxContainers(v.target.value);
    setCanvasModified(true);
    values.maxContainers=parseInt(v.target.value);
    values.maxContainers=parseInt(v.target.value);
    handlePublishContainers(()=>{
      //window.location.reload();
    },()=>{
      values.maxContainers=maxContainers;
      setMaxContainers(maxContainers);
    });
  }
  const handlerTimeLinePickerOnChange=(data)=>{
    // setDateSelected(data.target.value);
    // onChangeDate(data.target.value);
    handleChangeDateTimeline(data.target.value);
    
  }
  return (
    <div className="canvasComponent" data-canvas-id={values.id}>
        <div className="canvas-top">
          {/* <CanvasPreviewButtons /> */}
          <CanvasPublishButtons position="top" />
        </div>
        <div className="canvasManagement">Canvas management</div>
        <div>
        <TimelineDatePicker
            id={"datePicker"}
            label="Choose date and hour"
            value={dateSelected}
            maxTime={maxTimeDisplayTimeline}
            minTime={minTime}
            onChange={(data) => handlerTimeLinePickerOnChange(data)}
            helpText={"Choose here the date and hour you want to see in the Canvas"}
        />
        </div>
        {values.operatingSystem==OPERATING_SYSTEMS.oculusQuest.key && <div className="canvas-max-containers">
            <FormConfirmSelect
                id={"maxContainers2"}
                key={"maxContainers2"}
                label={"Max Number of Containers"}
                value={maxContainers}
                placeholder="placeholder"
                helpText="set here the num.max of containers"
                confirmChange={true}
                confirmTitle="Are you sure you want to change the max number of containers?"
                confirmText="If you reduce the containers you will lose information"
                
                options={ [
                  { name: '3', value: '3' },
                  { name: '4', value: '4' },
                  { name: '5', value: '5' },
                  { name: '6', value: '6' },
                  { name: '7', value: '7' },
                ]}
                onChange={handleOnChangeMaxContainers}
              />    
        </div>}
        <div className='canvas-middle'>
          <TimelineComponent value={dataToTimeline} 
              dateSelected={dateSelected} 
              blockSelected={blockSelected}
              // onChangeDate={handleChangeDateTimeline}
              onSelectItem={handleOnSelectItem}
              onDeselectItem={handleOnDeselectItem} 
              onMoveAndSelectItem={handleMoveAndSelectItem}
              onMoveTime={handleOnMoveTime}
              onDeleteBlock={handleOnDeleteBlock}
              onFillBlock={handleOnFillBlock}
              onMoveToEnd={handleOnMoveToEnd}
              minTime={minTime}
              maxTime={maxTime}
              maxTimeDisplayTimeline={maxTimeDisplayTimeline}

              />
        </div>
        <div>
          <div className='canvas-middle'>
              <div className='canvas-preview-buttons canvas-middle-padding'>
                <CanvasPreviewButtons />
              </div>
              <div className="topScrollbar"><div className="topScrollbarContent">&nbsp;</div></div>
              <div className="groupContainers-parent">
                <div className="canvas-middle-padding">
                  
                  <div className="groupContainers">
                    <div className="vertical-line">
                      <span className="vertical-line-text vertical-line-text--top" onClick={handleRecenterCanvas}>Center</span>
                      <span className="vertical-line-text vertical-line-text--bottom" onClick={handleRecenterCanvas}>Center</span>
                    </div>
                    
                    {values.operatingSystem==OPERATING_SYSTEMS.oculusQuest.key && containersTop &&  
                      <CanvasContainers 
                          key={"Top"}
                          mode={modePreview} 
                          canvasMode={"Top"}
                          updateCanvas={updateCanvas}
                          onUpdateContainer={onUpdate} 
                          onUpdateInfoContent={onUpdateInfoContent}
                          onDeleteContainer={onDeleteContainer} 
                          onNewContainer={onNewContainer} 
                          onBlockSelected={handleOnBlockSelected}
                          containers={containersTop}
                          refresh={triggerRefresh}
                          infoContent={infoContent}
                          dateSelected={dateSelected} 
                          blockSelected={blockSelected}/>
                    }
                    {values.operatingSystem==OPERATING_SYSTEMS.oculusQuest.key && containersMiddle &&  
                      <CanvasContainers 
                          key="Middle"
                          mode={modePreview} 
                          canvasMode={"Middle"}
                          updateCanvas={updateCanvas}
                          onUpdateContainer={onUpdate} 
                          onUpdateInfoContent={onUpdateInfoContent}
                          onDeleteContainer={onDeleteContainer} 
                          onNewContainer={onNewContainer} 
                          onBlockSelected={handleOnBlockSelected}
                          containers={containersMiddle}
                          refresh={triggerRefresh}
                          infoContent={infoContent}
                          dateSelected={dateSelected} 
                          blockSelected={blockSelected}/>
                    }
                    {values.operatingSystem==OPERATING_SYSTEMS.oculusQuest.key && containersBottom &&  
                      <CanvasContainers 
                          key={"Bottom"}
                          mode={modePreview} 
                          canvasMode={"Bottom"}
                          updateCanvas={updateCanvas}
                          onUpdateContainer={onUpdate} 
                          onUpdateInfoContent={onUpdateInfoContent}
                          onDeleteContainer={onDeleteContainer} 
                          onNewContainer={onNewContainer} 
                          onBlockSelected={handleOnBlockSelected}
                          containers={containersBottom}
                          refresh={triggerRefresh}
                          infoContent={infoContent}
                          dateSelected={dateSelected} 
                          blockSelected={blockSelected}/>
                    }
                    {(values.operatingSystem==OPERATING_SYSTEMS.androidXR.key || values.operatingSystem==OPERATING_SYSTEMS.visionOS.key) && containersMiddle &&  
                      <CanvasContainersScrollable
                          key="Middle"
                          mode={modePreview} 
                          canvasMode={"Middle"}
                          updateCanvas={updateCanvas}
                          onUpdateContainer={onUpdate} 
                          onUpdateInfoContent={onUpdateInfoContent}
                          onDeleteContainer={onDeleteContainer} 
                          onNewContainer={onNewContainer} 
                          onBlockSelected={handleOnBlockSelected}
                          containers={containersMiddle}
                          refresh={triggerRefresh}
                          infoContent={infoContent}
                          dateSelected={dateSelected} 
                          blockSelected={blockSelected}/>
                    }
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div className='canvas-bottom'>
          <CanvasPublishButtons position="bottom" />
        </div>
        {Object.keys(popupMessages).length > 0
          && (
            <Toaste type="info" mode="normal" data={popupMessages} />
          )}
      </div>);
};

CanvasComponent.propTypes = {
     /**
      * Function to propagate to parent to send to server the object
      */
     onPublish:PropTypes.func,
     values:PropTypes.oneOfType([PropTypes.object,PropTypes.array])
};

CanvasComponent.defaultProps = {
    values:{},
};
export default CanvasComponent;
